export function formatMenuListItems(menu, analytics) {
    var setupTracker = function (description) {
        var id = "Header." + description;
        var callback = function (_id, _description) {
            // eslint-disable-next-line no-unused-expressions
            analytics && analytics.clickTracker(_id, _description, {}, function () { return null; }, true)();
        };
        return {
            callback: callback,
            description: description,
            id: id
        };
    };
    return menu
        && menu.data
        && menu.data.map(function (link) { return ({
            id: link.id,
            analytics: setupTracker(link.trackingEvent),
            className: 'uitk-list-item',
            label: link.text,
            href: link.url,
            typeAnchor: true,
            attributes: {
                role: 'menuitem',
                tabindex: 0
            },
            icon: link.iconName
        }); });
}
//# sourceMappingURL=header-nav-menu-links-util.js.map